import React, { useState} from "react";
import OutsideClickHandler from "react-outside-click-handler";
import classNames from "classnames";
import HelpModal from './help/HelpModal';


const HelpButton = () => {
  const [isModalOpen, toggleModal] = useState(false)

  const showModal = () => {
    toggleModal(true)
  }

  const closeModal = (event) => {
    toggleModal(false)
  }

  return (
    <div>
      <a className="btn btn-form help" onClick={showModal}>
        <i className="fi fi-question"></i>
      </a>
      { isModalOpen && <HelpModal closeModal={closeModal} /> }
    </div>
  );
}

export default HelpButton
